import React, { useEffect } from "react";

export function useDebouncedState<T>(debouncedBy: number, initial: T) {
  const [value, setValue] = React.useState(initial);
  const [debouncedValue, setDebouncedValue] = React.useState(initial);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, debouncedBy);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, debouncedBy]);

  return {
    value,
    debouncedValue,
    setValue,
  };
}
